import type { ReleaseRequest, ReleaseResponse } from '../types/release';

// Determine the API base URL based on environment
function getApiBaseUrl(): string {
    // Check if we're in development mode
    if (import.meta.env.DEV) {
        return 'http://localhost:8080';
    }
    
    // Production - use your Render URL (proxied through Cloudflare)
    return 'https://api.robwebb.co.uk';
}

export class ReleaseClient {
    private baseUrl: string;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl || getApiBaseUrl();
    }

    async generateRelease(data: ReleaseRequest): Promise<ReleaseResponse> {
        const response = await fetch(`${this.baseUrl}/api/releases/generate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return response.json();
    }

    async post<T>(url: string, data: unknown): Promise<T> {
        const response = await fetch(`${this.baseUrl}${url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return response.json();
    }

    stream(url: string): EventSource {
        // This is a simplified implementation. For production, you'd want to handle auth tokens etc.
        const eventSource = new EventSource(`${this.baseUrl}${url}`);
        return eventSource;
    }

    async generateAssets(data: unknown): Promise<any> {
        return this.post('/api/assets/generate', data);
    }
}